module.exports = __webpack_public_path__ + "img/template-active.df85258b.svg";